// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"122":"ccfc28947909c22c","6714":"7d512a6d2004818c"}[chunkId] + ".css";
};